(function (SingleResearch, $, window, document) {
  'use strict';
  //## GENERAL Scripts
  var generalScripts = (function () {
    var GLOBS = {
      $body: $('body'),
      $doc: $(document),
      loader: document.getElementById('loader'),
      visibleClass: 'is--visible',
      activeClass: 'is--active',
    };
    //Binds all handle functions to a new function which is called @init
    var bindEvents = function () {
      function getParameterByName(name, url) {
        if (!url) url = window.location.href;
        name = name.replace(/[\[\]]/g, '\\$&');
        var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
          results = regex.exec(url);
        if (!results) return null;
        if (!results[2]) return '';
        return decodeURIComponent(results[2].replace(/\+/g, ' '));
      }
      var newsList = [];
      //Default Rest
      var articleID = getParameterByName('researchid');
      //Clear Html

      function clearRelated() {
        $('.research-col').remove();
      }
      String.prototype.trimEllip = function (length) {
        return this.length > length ? this.substring(0, length) + '...' : this;
      };
      //*RENDER
      function renderSingle(article) {
        var singleResearch = '';
        var firstAuthorID = article.contributors.preview[0].first_name ? article.contributors.preview[0].first_name + ' ' + article.contributors.preview[0].surname : '';
        singleResearch += "<div class='single-article__title block-section' data-aos='fade-up' data-aos-delay='200' data-author='" + firstAuthorID + "'>";
        singleResearch += "    <div class='container'>";
        if (article.title) {
          var title;
          if (article.title.en) {
            title = article.title.en;
          } else {
            title = Object.values(article.title)[0];
          }
          singleResearch += '      <h1>' + title + '</h1>';
        }
        singleResearch += "      <div class='single-research__authors'>";
        if (article.contributors) {
          var authorList = article.contributors.preview;

          authorList.forEach(function (author) {
            singleResearch += '      <span>' + author.first_name + ' ' + author.surname + '</span>';
          });
        }
        singleResearch += '      </div>';
        singleResearch += '    </div>';
        singleResearch += '  </div>';
        singleResearch += "  <main class='single-article__content' data-aos='fade-up' data-aos-delay='300'>";
        singleResearch += "    <div class='container'>";
        singleResearch += "      <div class='outer-wrap'>";
        singleResearch += "        <div class='single-research__left'>";
        //if (article.links) {
        //  singleResearch += "          <div class='layout-block hidden layout-text-block original-version article-block'>";
        //  singleResearch += "            <p><strong>Original version</strong></p>";
        //  singleResearch += "            <p><a href='" + article.links[0].url + "' target='_blank'>" + article.links[0].url + "</a></p>";
        //  singleResearch += "          </div>";
        //}
        if (article.summary) {
          var summary;
          if (article.summary.en) {
            summary = article.summary.en;
          } else {
            summary = Object.values(article.summary)[0];
          }
          singleResearch += "          <div class='layout-block layout-text-block abstract article-block'>";
          singleResearch += '            <p><strong>Abstract</strong></p>';
          singleResearch += '            <p>' + summary + '</p>';
          singleResearch += '          </div>';
        }
        if (article.publisher) {
          var publisher = article.publisher.name;
          singleResearch += "          <div class='layout-block layout-text-block publisher-version article-block'>";
          singleResearch += '            <p><strong>Publisher</strong></p>';
          singleResearch += '            <p>' + publisher + '</p>';
          singleResearch += '          </div>';
        }
        if (article.journal) {
          singleResearch += "          <div class='layout-block layout-text-block publisher-version article-block'>";
          singleResearch += '            <p><strong>Journal</strong></p>';
          singleResearch += '            <p>' + article.journal.name + '</p>';
          singleResearch += '          </div>';
        }

        singleResearch += '        </div>';
        singleResearch += "        <aside class='single-research__right'>";
        singleResearch += "          <div class='research-info hidden'>";
        singleResearch += '            <p><strong>NOT AVAILABLE IN API / Journal article, Peer reviewed</strong></p>';
        singleResearch += '          </div>';
        singleResearch += "          <div class='research-info hidden'>";
        singleResearch += '            <p><strong>NOT AVAILABLE IN API / Accepted version</strong></p>';
        singleResearch += '          </div>';
        if (article.open_access) {
          singleResearch += "          <div class='research-info'>";
          singleResearch += '            <p><strong>View/Open</strong></p>';
          if (article.open_access == 'none') {
            singleResearch += "            <p class='locked'>(Locked)</p>";
          } else {
            singleResearch += "            <p><a href='" + article.links[0].url + "' target='_blank'>" + article.links[0].url + '</a></p>';
          }
          singleResearch += '          </div>';
        }
        if (article.links) {
          singleResearch += "          <div class='research-info'>";
          singleResearch += '            <p><strong>URI</strong></p>';
          article.links.forEach(function (link) {
            singleResearch += "            <p style='margin-bottom:10px!important'><a href='" + link.url + "' target='_blank'>" + link.url + '</a></p>';
          });
          singleResearch += '          </div>';
        }
        singleResearch += "          <div class='research-info'>";
        singleResearch += '            <p><strong>Date</strong></p>';
        if (article.year_published) {
          singleResearch += '            <p>' + article.year_published + '</p>';
        }
        singleResearch += '          </div>';
        singleResearch += "          <div class='research-info hidden'>";
        singleResearch += '            <p><strong>NOT IN API / Metadata</strong></p>';
        singleResearch += '            <p> Show full item record</p>';
        singleResearch += '          </div>';
        singleResearch += "          <div class='research-info hidden'>";
        singleResearch += '            <p><strong>Collections</strong></p>';
        singleResearch += '            <p> Institutt for datateknologi og informatikk [3730]';
        singleResearch += '              Publikasjoner fra CRIStin - NTNU [19118]</p>';
        singleResearch += '          </div>';
        singleResearch += '        </aside>';
        singleResearch += '      </div>';
        singleResearch += '    </div>';
        singleResearch += '  </main>';

        $(GLOBS.loader).hide();
        document.getElementById('ajax-article').innerHTML += singleResearch;
      }
      function renderRelated(rlArticle) {
        var researchHtml = '';
        rlArticle.forEach(function (article) {
          var authorList = article.contributors.preview;
          var title;
          if (article.title.en) {
            title = article.title.en;
          } else {
            title = Object.values(article.title)[0];
          }
          var url = singleResearchUrl + '?researchid=' + article.cristin_result_id;
          researchHtml += "<div class='column-6 research-col column-mob-12'>";
          researchHtml += "<article class='research-article' id='" + article.cristin_result_id + "'>";
          researchHtml += "  <a href='" + url + "'>";
          researchHtml += "    <h3 class='research-article__title'>" + title + '</h3>';
          researchHtml += "    <div class='research-article__authors'>";
          authorList.forEach(function (author) {
            researchHtml += '      <span>' + author.first_name + ' ' + author.surname + '</span>';
          });
          researchHtml += '    </div>';
          if (article.summary) {
            var excerpt = article.summary.en ? article.summary.en.trimEllip(100) : article.summary.no.trimEllip(100);
            researchHtml += "    <p class='research-article__excerpt'>" + excerpt + '</p>';
          }
          researchHtml += '  </a>';
          researchHtml += "  <a href='" + url + "' class='research-article__readmore'>Read the summary</a>";
          researchHtml += '</article>';
          researchHtml += '</div>';
        });
        $('#loader-related').hide();
        clearRelated();
        document.getElementById('ajax-related').innerHTML += researchHtml;
      }
      //* FETCH
      function fetchSingleResearch(articleID) {
        $(GLOBS.loader).show();
        var data = {};
        data['fields'] = 'all';
        axios
          .get('https://api.cristin.no/v2/results/' + articleID, {
            params: data,
          })
          .then(function (response) {
            renderSingle(response.data);
            console.log(response.data);
            //Fetch related based on author
            var relatedAuthor = $('.single-article__title').data('author');
            fetchRelated(relatedAuthor);
          })
          .catch(function (error) {
            console.log(error);
            $(GLOBS.loader).hide();
            $('#load-more').hide();
          });
      }
      function fetchRelated(author) {
        $('#loader-related').show();
        var data = {};
        data['page'] = 1;
        data['per_page'] = 2;
        data['fields'] = 'all';
        data['lang'] = 'en';
        data['id'] = 2032288;
        axios
          .get('https://api.cristin.no/v2/results', {
            params: data,
          })
          .then(function (relatedResponse) {
            if (relatedResponse.data.length == 0) {
              $('#notfoundtext-related').show();
            } else {
              $('#notfoundtext-related').hide();
            }
            renderRelated(relatedResponse.data);
          })
          .catch(function (error) {
            console.log(error);
            $('#loader-related').hide();
          });
      }

      if (document.getElementById('ajax-article')) {
        fetchSingleResearch(articleID);
      }
    };
    //End BIND
    //Inits Functions and Events
    var init = function () {
      bindEvents();
    };
    //END INIT
    //Inits Plugins
    var initPlugins = function () {};
    //END INIT PLUGINS
    return {
      init: init,
      initPlugins: initPlugins,
    };
  })();
  //## END GENERAL Scripts
  //## SingleResearch MAIN
  var SingleResearchMain = (function () {
    var init = function () {
      generalScripts.init();
      generalScripts.initPlugins();
    };
    return {
      init: init,
    };
  })();
  //## END SingleResearch MAIN
  //Doc Ready
  document.addEventListener(
    'DOMContentLoaded',
    function () {
      SingleResearchMain.init();
    },
    false
  );
})((window.SingleResearch = window.SingleResearch || {}), window.jQuery, window, document);
